import {
  RichiestaDTO,
  useGetFrontRichiesteIdIntegrate,
} from '@framework/api-client';
import { SubmissionCardTabPanel } from '@framework/common-web';
import { t } from '@framework/i18n';
import { Flex } from 'antd';
import { IntegrationRows } from './IntegrationRows';

export interface ISubmissionSentTabIntegrationsProps {
  active?: boolean;
  title?: string;
  submission?: RichiestaDTO | undefined;
}

/**
 * Tab delle comunicazioni post invio di una richiesta richiesta.
 */
export function SubmissionSentTabIntegrations(
  props: ISubmissionSentTabIntegrationsProps,
) {
  const { active, submission } = props;
  const { data: integrations } = useGetFrontRichiesteIdIntegrate(
    submission!.id!,
  );

  if (!active) return null;

  return (
    <SubmissionCardTabPanel
      active={active}
      label={t(
        'submission-sent-tab-integrations.panel-aria',
        'Tab Integrazioni della richiesta',
      )}
    >
      <Flex vertical gap={32}>
        <IntegrationRows
          integrations={integrations}
          submissionId={submission?.id}
        />
      </Flex>
    </SubmissionCardTabPanel>
  );
}
